import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityIndicators = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      text: 'SSL Encrypted'
    },
    {
      icon: 'Lock',
      text: 'Secure Login'
    },
    {
      icon: 'Eye',
      text: 'Privacy Protected'
    }
  ];

  return (
    <div className="flex items-center justify-center space-x-6 py-4">
      {securityFeatures?.map((feature, index) => (
        <div key={index} className="flex items-center space-x-2">
          <Icon 
            name={feature?.icon} 
            size={14} 
            className="text-success" 
          />
          <span className="text-xs text-muted-foreground">
            {feature?.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SecurityIndicators;